import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  completeStep,
  completeOnboarding,
  saveOnboarding,
  selectOnboardingForRole,
  ONBOARDING_STEPS,
} from "../../../slices/onboardingSlice";
import { useOnboardingRole } from "./useOnboardingRole";

export function useCompleteStep(stepKey: string) {
  const dispatch = useAppDispatch();
  const role = useOnboardingRole();
  const onboarding = useAppSelector(selectOnboardingForRole(role));

  const steps = ONBOARDING_STEPS[role];
  const stepIndex = steps.findIndex((s) => s.key === stepKey);
  const isLastStep = stepIndex === steps.length - 1;
  const dashboardPath = `/${role.toLowerCase()}`;

  const complete = useCallback(() => {
    dispatch(completeStep({ role, step: stepIndex }));

    const updatedSteps = [...onboarding.completedSteps];
    updatedSteps[stepIndex] = true;

    const nextStep = stepIndex + 1 < steps.length ? stepIndex + 1 : stepIndex;
    const willComplete = isLastStep;

    if (willComplete) {
      dispatch(completeOnboarding({ role }));
    }

    dispatch(
      saveOnboarding({
        role,
        current_step: willComplete ? stepIndex : nextStep,
        completed_steps: updatedSteps,
        is_complete: willComplete ? true : onboarding.isComplete,
        is_skipped: onboarding.isSkipped,
      })
    );
  }, [dispatch, role, stepIndex, isLastStep, onboarding, steps.length]);

  return { complete, dashboardPath, isLastStep, role, stepIndex, onboarding };
}
